export default __webpack_public_path__ + "static/media/meditating.bc6a2adb.png";